import { render } from "./Product-popup.vue?vue&type=template&id=65012faf&scoped=true"
import script from "./Product-popup.vue?vue&type=script&lang=js"
export * from "./Product-popup.vue?vue&type=script&lang=js"

import "./Product-popup.vue?vue&type=style&index=0&id=65012faf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65012faf"]])

export default __exports__